<template>
  <div id="app">
    <template v-if="!isInDFM">
		<Top></Top>
		<Nav/>
		</template>
		<DfmNav2 v-if="isInDFM" />
		<transition name="fade">
      <div v-if="isLoadingPage" class="loading-overlay loading-color" v-loading="true"  element-loading-background="rgba(255, 255, 255, 0.8)" element-loading-text="loading..."></div>
    </transition>
		<transition name="fade">
    	<router-view/>
		</transition>
		<Foot v-if="!isInDFM"></Foot>
  </div>
</template>
<script>
import Top from './components/top.vue'
import Nav from './components/nav.vue'
import Foot from './components/foot.vue'
import DfmNav2 from './components/dfmNav2.vue'
export default {
	name: 'App',
	data() {
		return {
			navfixed:false
		}
	},
	mounted(){
		//獲取當前頁面鏈接，並跳轉		
		console.log('APP.vue', this.STAY)
		// if(this.STAY){
		// 	this.$router.replace(this.STAY);
		// }
		//初始化計價參數
		this.$store.dispatch("resetQuoteParams");
		//初始化nextpcb配置的图片等参数
		this.$store.dispatch("getCommonData");
		//獲取多語言包 如果是個人中心時需要將key換成member
		// this.$store.dispatch("changeLang",{key:"home"});
		//统计代码
		this.analytics();
		//
		// this.setSsoLogin();
		//通过id获取参数
		let quoteid = this.$tools.getUrlParams("quoteid");
		let query = this.$route.query;
		if(query.quoteid || quoteid){
			this.$store.dispatch("getAjaxQuoteParams",query.quoteid || quoteid);
		}	
		let _this = this;
		window.onscroll = function(){
			//let e =e || window.event;
			let scrolltop = document.documentElement.scrollTop || document.body.scrollTop;	
			let offsetTop = _this.$el.offsetTop;
			if(scrolltop > offsetTop){
				_this.navfixed = true;
			}else{
				_this.navfixed = false;
			}
		}	
	},
	computed:{
		top(){
			return this.$store.getters.getTopData;
		},
		isInDFM(){
			if(window.isInDFM){
				return JSON.parse(window.isInDFM)
			}
			else{
				return false
			}
		},
		isLoadingPage() {
			return this.$store.state.isLoadingPage
		}
	},
	methods:{
		// 导航跳转链接
		hrefShow(href) {
			if(href === '/hqonline') {
				return this.$tools.getHqonlineUrl()
			} else {
				return href
			}
		},
		setSsoLogin(){
			var sso = localStorage.getItem("tokenContent");	
			if(sso){	
				sso = JSON.parse(sso);
				let _this = this;
				localStorage.setItem("token",sso.token);	
				this.$http.get(sso.url,{params:{content:sso.content}}).then((res)=>{					
					if(res.status == 200){
						localStorage.removeItem("tokenContent");
						_this.$store.dispatch("getCommonData");
						//window.location.reload();
					}
				});
			}
		},
		analytics(){
			let page = document.location.href;
			let referer = document.referrer;
			if(page.split("#").length){
				page = page.split("#")[0];
			}
			let uvdata = {
				'_page': page,
				'_ref': referer,
				'g_tk': getACSRFToken()
			};			
			this.$http.post('/ajax/analytics',uvdata);
			// 获取cookie
			function getCookie(name) {
				var arr = document.cookie.match(new RegExp("(^| )" + name + "=([^;]*)(;|$)"));
				if (arr != null) return unescape(arr[2]);
				return null;
			}			
			function getACSRFToken() {				
				return getCookie("skey") == "" ? (getCookie("PHPSESSID") ? getCookie("PHPSESSID") : 'null')  : (getCookie("skey") ? getCookie("skey") : 'null');
			}
		}
	},
	watch:{
		$route(to,from){
			this.$store.commit("setRouteInfo",{to:to,from:from});			
		},
		langData(val) {
			// this.LANG = val
			console.log('langData',this.LANG)
		}
	},
	components: {
		Top,
		Nav,
		Foot,
		DfmNav2
	}
}
</script>
<style lang="scss">
 @import "@/assets/_module/base.scss";
 .loading-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  // background-color: rgba(255, 255, 255, 0.8);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9999;
}

.fade-enter-active, .fade-leave-active {
  transition: opacity 0.5s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}

.loading-color {
	color: #c00;

	.el-loading-spinner .path {
		stroke: #c00;
	}

	.el-loading-spinner .el-loading-text {
		color: #c00;
	}
}
</style>
